export default [
    {
        label: 'کالای دیجیتال',
        text: 'کالای دیجیتال'
    },
    {
        label: 'کالای دیجیتال > کامپیوتر و تجهیزات جانبی',
        text: 'کامپیوتر و تجهیزات جانبی'
    },
    {
        label: 'کالای دیجیتال > گوشی موبایل',
        text: 'گوشی موبایل'
    },
    {
        label: 'کالای دیجیتال > لوازم جانبی گوشی',
        text: 'لوازم جانبی گوشی'
    },
    {
        label: 'کالای دیجیتال > ساعت و مچ‌بند هوشمند',
        text: 'ساعت و مچ‌بند هوشمند'
    },
    {
        label: 'کالای دیجیتال > لوازم جانبی ساعت و مچ‌بند هوشمند',
        text: 'لوازم جانبی ساعت و مچ‌بند هوشمند'
    },
    {
        label: 'کالای دیجیتال > دوربین',
        text: 'دوربین'
    },
    {
        label: 'کالای دیجیتال > لپ تاپ',
        text: 'لپ تاپ'
    },
    {
        label: 'کالای دیجیتال > لوازم جانبی لپ تاپ',
        text: 'لوازم جانبی لپ تاپ'
    },
    {
        label: 'کالای دیجیتال > تبلت و کتابخوان',
        text: 'تبلت و کتابخوان'
    },
    {
        label: 'کالای دیجیتال > لوازم جانبی تبلت',
        text: 'لوازم جانبی تبلت'
    },
    {
        label: 'کالای دیجیتال > ماشین‌های اداری',
        text: 'ماشین‌های اداری'
    },



    {
        label: 'مد و پوشاک',
        text: 'مد و پوشاک'
    },
    {
        label: 'مد و پوشاک > لباس مردانه',
        text: 'لباس مردانه'
    },
    {
        label: 'مد و پوشاک > کفش مردانه',
        text: 'کفش مردانه'
    },
    {
        label: 'مد و پوشاک > اکسسوری مردانه',
        text: 'اکسسوری مردانه'
    },
    {
        label: 'مد و پوشاک > ورزشی مردانه',
        text: 'ورزشی مردانه'
    },
    {
        label: 'مد و پوشاک > لباس زنانه',
        text: 'لباس زنانه'
    },
    {
        label: 'مد و پوشاک > کفش زنانه',
        text: 'کفش زنانه'
    },
    {
        label: 'مد و پوشاک > اکسسوری زنانه',
        text: 'اکسسوری زنانه'
    },
    {
        label: 'مد و پوشاک > ورزشی زنانه',
        text: 'ورزشی زنانه'
    },
    {
        label: 'مد و پوشاک > لباس دخترانه',
        text: 'لباس دخترانه'
    },
    {
        label: 'مد و پوشاک > کفش دخترانه',
        text: 'کفش دخترانه'
    },
    {
        label: 'مد و پوشاک > اکسسوری دخترانه',
        text: 'اکسسوری دخترانه'
    },
    {
        label: 'مد و پوشاک > لباس پسرانه',
        text: 'لباس پسرانه'
    },
    {
        label: 'مد و پوشاک > کفش پسرانه',
        text: 'کفش پسرانه'
    },
    {
        label: 'مد و پوشاک > اکسسوری پسرانه',
        text: 'اکسسوری پسرانه'
    },
    {
        label: 'مد و پوشاک > نوزاد',
        text: 'نوزاد'
    },
    {
        label: 'مد و پوشاک > طلا و جواهرات',
        text: 'طلا و جواهرات'
    },



    {
        label: 'زیبایی و سلامت',
        text: 'زیبایی و سلامت'
    },
    {
        label: 'زیبایی و سلامت > لوازم آرایشی',
        text: 'لوازم آرایشی'
    },
    {
        label: 'زیبایی و سلامت > لوازم بهداشتی',
        text: 'لوازم بهداشتی'
    },
    {
        label: 'زیبایی و سلامت > لوازم شخصی برقی',
        text: 'لوازم شخصی برقی'
    },
    {
        label: 'زیبایی و سلامت > عطر، ادکلن، اسپری و ست',
        text: 'عطر، ادکلن، اسپری و ست'
    },
    {
        label: 'زیبایی و سلامت > ابزار سلامت و طبی',
        text: 'ابزار سلامت و طبی'
    },
    {
        label: 'زیبایی و سلامت > خدمات زیبایی و سلامت',
        text: 'خدمات زیبایی و سلامت'
    },



    {
        label: 'خانه و آشپزخانه',
        text: 'خانه و آشپزخانه'
    },
    {
        label: 'خانه و آشپزخانه > صوتی و تصویری',
        text: 'صوتی و تصویری'
    },
    {
        label: 'خانه و آشپزخانه > دکوراتیو',
        text: 'دکوراتیو'
    },
    {
        label: 'خانه و آشپزخانه > لوازم خانگی برقی',
        text: 'لوازم خانگی برقی'
    },
    {
        label: 'خانه و آشپزخانه > حیوانات خانگی، غذا و لوازم',
        text: 'حیوانات خانگی، غذا و لوازم'
    },
    {
        label: 'خانه و آشپزخانه > سرو و پذیرایی',
        text: 'سرو و پذیرایی'
    },
    {
        label: 'خانه و آشپزخانه > نور و روشنایی',
        text: 'نور و روشنایی'
    },
    {
        label: 'خانه و آشپزخانه > آشپزخانه',
        text: 'آشپزخانه'
    },
    {
        label: 'خانه و آشپزخانه > وسایل حمام و سرویس بهداشتی',
        text: 'وسایل حمام و سرویس بهداشتی'
    },
    {
        label: 'خانه و آشپزخانه > ملحفه، سرویس، لوازم خواب',
        text: 'ملحفه، سرویس، لوازم خواب'
    },
    {
        label: 'خانه و آشپزخانه > فرش ماشینی، دستبافت، تابلو',
        text: 'فرش ماشینی، دستبافت، تابلو'
    },



    {
        label: 'کالاهای سوپرمارکتی',
        text: 'کالاهای سوپرمارکتی'
    },
    {
        label: 'کالاهای سوپرمارکتی > مواد غذایی',
        text: 'مواد غذایی'
    },
    {
        label: 'کالاهای سوپرمارکتی > نوشیدنی و دمنوش‌ها',
        text: 'نوشیدنی و دمنوش‌ها'
    },
    {
        label: 'کالاهای سوپرمارکتی > خواربار',
        text: 'خواربار'
    },
    {
        label: 'کالاهای سوپرمارکتی > بهداشت خانگی',
        text: 'بهداشت خانگی'
    },
    {
        label: 'کالاهای سوپرمارکتی > میوه و سبزیجات',
        text: 'میوه و سبزیجات'
    },
    {
        label: 'کالاهای سوپرمارکتی > مکمل غذایی و دارویی',
        text: 'مکمل غذایی و دارویی'
    },



    {
        label: 'کتاب، لوازم التحریر و هنر',
        text: 'کتاب، لوازم التحریر و هنر'
    },
    {
        label: 'کتاب، لوازم التحریر و هنر > کتاب و مجله',
        text: 'کتاب و مجله'
    },
    {
        label: 'کتاب، لوازم التحریر و هنر > لوازم التحریر',
        text: 'لوازم التحریر'
    },
    {
        label: 'کتاب، لوازم التحریر و هنر > محصولات فرهنگی',
        text: 'محصولات فرهنگی'
    },
    {
        label: 'کتاب، لوازم التحریر و هنر > صنایع دستی',
        text: 'صنایع دستی'
    },
    {
        label: 'کتاب، لوازم التحریر و هنر > لوازم عبادت',
        text: 'لوازم عبادت'
    },
    {
        label: 'کتاب، لوازم التحریر و هنر > مراسم و مناسبت‌ها',
        text: 'مراسم و مناسبت‌ها'
    },



    {
        label: 'ابزار و تجهیزات',
        text: 'ابزار و تجهیزات'
    },
    {
        label: 'ابزار و تجهیزات > لوازم جانبی خودرو',
        text: 'لوازم جانبی خودرو'
    },
    {
        label: 'ابزار و تجهیزات > لوازم جانبی موتور سیکلت',
        text: 'لوازم جانبی موتور سیکلت'
    },
    {
        label: 'ابزار و تجهیزات > ردیاب',
        text: 'ردیاب'
    },
    {
        label: 'ابزار و تجهیزات > تجهیزات تردد، حفاظت و امنیت',
        text: 'تجهیزات تردد، حفاظت و امنیت'
    },
    {
        label: 'ابزار و تجهیزات > تجهیزات ایمنی و کار',
        text: 'تجهیزات ایمنی و کار'
    },
    {
        label: 'ابزار و تجهیزات > ابزار برقی و شارژی',
        text: 'ابزار برقی و شارژی'
    },
    {
        label: 'ابزار و تجهیزات > ابزار غیر برقی',
        text: 'ابزار غیر برقی'
    },
    {
        label: 'ابزار و تجهیزات > لوازم و یرآق آلات ساختمانی',
        text: 'لوازم و یرآق آلات ساختمانی'
    },
    {
        label: 'ابزار و تجهیزات > لوازم باغبانی',
        text: 'لوازم باغبانی'
    },
    {
        label: 'ابزار و تجهیزات > نور و روشنایی',
        text: 'نور و روشنایی'
    },

    {
        label: 'قفسه و تجهیزات فروشگاهی > قفسه و تجهیزات فروشگاهی',
        text: 'قفسه و تجهیزات فروشگاهی',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > قفسه فروشگاهی',
        text: 'قفسه فروشگاهی',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > قفسه انباری',
        text: 'قفسه انباری',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > نردبان',
        text: 'نردبان',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > جاخشکباری و حبوباتی',
        text: 'جاخشکباری و حبوباتی',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > استند',
        text: 'استند',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > تجهیزات فروشگاهی',
        text: 'تجهیزات فروشگاهی',
    },
    {
        label: 'قفسه و تجهیزات فروشگاهی > رگال',
        text: 'رگال',
    },

    {
        label: 'ورزش و سفر',
        text: 'ورزش و سفر'
    },
    {
        label: 'ورزش و سفر > پوشاک ورزشی مردانه',
        text: 'پوشاک ورزشی مردانه'
    },
    {
        label: 'ورزش و سفر > پوشاک ورزشی زنانه',
        text: 'پوشاک ورزشی زنانه'
    },
    {
        label: 'ورزش و سفر > کفش ورزشی مردانه',
        text: 'کفش ورزشی مردانه'
    },
    {
        label: 'ورزش و سفر > کفش ورزشی زنانه',
        text: 'کفش ورزشی زنانه'
    },
    {
        label: 'ورزش و سفر > پوشاک ورزشی دخترانه',
        text: 'پوشاک ورزشی دخترانه'
    },
    {
        label: 'ورزش و سفر > پوشاک ورزشی پسرانه',
        text: 'پوشاک ورزشی پسرانه'
    },
    {
        label: 'ورزش و سفر > کفش ورزشی دخترانه',
        text: 'کفش ورزشی دخترانه'
    },
    {
        label: 'ورزش و سفر > کفش ورزشی پسرانه',
        text: 'کفش ورزشی پسرانه'
    },
    {
        label: 'ورزش و سفر > تجهیزات سفر',
        text: 'تجهیزات سفر'
    },
    {
        label: 'ورزش و سفر > دوچرخه',
        text: 'دوچرخه'
    },
    {
        label: 'ورزش و سفر > کوهنوردی و کمپینگ',
        text: 'کوهنوردی و کمپینگ'
    },
    {
        label: 'ورزش و سفر > لوازم جانبی کوهنوردی و سفر',
        text: 'لوازم جانبی کوهنوردی و سفر'
    },
    {
        label: 'ورزش و سفر > لوازم ورزشی',
        text: 'لوازم ورزشی'
    },
    {
        label: 'ورزش و سفر > مجموعه‌های ورزشی',
        text: 'مجموعه‌های ورزشی'
    },
    {
        label: 'ورزش و سفر > کلاس‌های ورزشی',
        text: 'کلاس‌های ورزشی'
    },
    {
        label: 'ورزش و سفر > مربی‌های ورزشی',
        text: 'مربی‌های ورزشی'
    },



    {
        label: 'اسباب بازی، کودک و نوزاد',
        text: 'اسباب بازی، کودک و نوزاد'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > ایمنی و مراقبت کودک',
        text: 'ایمنی و مراقبت کودک'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > تغذیه و رشد کودک',
        text: 'تغذیه و رشد کودک'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > پستانک و لوازم شیردهی',
        text: 'پستانک و لوازم شیردهی'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > بهداشت و حمام کودک',
        text: 'بهداشت و حمام کودک'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > لوازم گردش و سفر کودک',
        text: 'لوازم گردش و سفر کودک'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > لوازم سرگرمی و آموزشی',
        text: 'لوازم سرگرمی و آموزشی'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > لوازم خواب کودک',
        text: 'لوازم خواب کودک'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > شوینده لباس کودک و نوزاد',
        text: 'شوینده لباس کودک و نوزاد'
    },
    {
        label: 'اسباب بازی، کودک و نوزاد > ملزومات اتاق کودک',
        text: 'ملزومات اتاق کودک'
    },



    {
        label: 'مالی و اقتصادی',
        text: 'مالی و اقتصادی'
    },
    {
        label: 'مالی و اقتصادی > درگاه پرداخت',
        text: 'درگاه پرداخت'
    },
    {
        label: 'مالی و اقتصادی > ارز دیجیتال',
        text: 'ارز دیجیتال'
    },
    {
        label: 'مالی و اقتصادی > کارگزاری',
        text: 'کارگزاری'
    },



    {
        label: 'آموزش و پرورش',
        text: 'آموزش و پرورش'
    },
    {
        label: 'آموزش و پرورش > آموزش مجازی و وبینار',
        text: 'آموزش مجازی و وبینار'
    },
    {
        label: 'آموزش و پرورش > سمینار',
        text: 'سمینار'
    },
    {
        label: 'آموزش و پرورش > آموزش حضوری',
        text: 'آموزش حضوری'
    },



    {
        label: 'خدمات آنلاین',
        text: 'خدمات آنلاین'
    },
    {
        label: 'خدمات آنلاین > خدمات سازمانی',
        text: 'خدمات سازمانی'
    },
    {
        label: 'خدمات آنلاین > سرویس‌های ابری',
        text: 'سرویس‌های ابری'
    },
    {
        label: 'خدمات آنلاین > اپراتور تلفن همراه و اینترنت',
        text: 'اپراتور تلفن همراه و اینترنت'
    },
    {
        label: 'خدمات آنلاین > خدمات پرداخت',
        text: 'خدمات پرداخت'
    },



    {
        label: 'خدمات',
        text: 'خدمات'
    },
    {
        label: 'خدمات > تعمیرات',
        text: 'تعمیرات'
    },
]
